import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from "react-toastify";

const ReportDownloadLoader = () => {
    const isReportDownloading = useSelector((state) => state.newJourney.isReportDownloading);
    const prevIsReportDownloading = useRef(isReportDownloading);

    useEffect(() => {
        if (prevIsReportDownloading.current === true && isReportDownloading === false) {
            toast.success("Successfully Downloaded Report");
        }
        prevIsReportDownloading.current = isReportDownloading;
    }, [isReportDownloading]);

    return (
        <div>
            {isReportDownloading && (
                <div style={{
                    display: "flex", gap: "10px", position: "absolute", right: "20px", top: "60px",
                    alignItems: "center", color: "#ff874d"
                }}>
                    <CircularProgress
                        sx={{ color: 'var(--primary-color-600)' }}
                        size={17}
                    />
                    <p>Report being generated</p>
                </div>
            )
            }
        </div>
    );
};

export default ReportDownloadLoader;
